import Monard81 from '../../../BSD/Armont/Monard/Monard 8.webp'
import Monard82 from '../../../BSD/Armont/Monard/Monard 8.webp'




const Monard8images =[
Monard81,Monard82
]

export default Monard8images;